import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';

const CodeBlock = ({ code, language }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        await navigator.clipboard.writeText(code);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="relative bg-pai-modal rounded-lg overflow-hidden my-4">
            {/* #345: the language label + "Copy" button are UI chrome, never
                content — data-clipboard-skip drops this whole bar from any
                selection copied out of the message (see clipboardSanitize.js). */}
            <div data-clipboard-skip="true" className="flex items-center justify-between px-4 py-2 bg-white/[0.05] border-b border-pai-hairline">
                <span className="text-sm text-white/25">{language || 'code'}</span>
                <button
                    onClick={handleCopy}
                    className="flex items-center gap-1 px-2 py-1 text-sm text-white/25 hover:text-white transition-colors"
                >
                    {copied ? <Check size={14} /> : <Copy size={14} />}
                    {copied ? 'Copied!' : 'Copy'}
                </button>
            </div>
            <pre className="p-4 overflow-x-auto">
                <code className="text-white text-sm font-mono">{code}</code>
            </pre>
        </div>
    );
};

export default CodeBlock;